module.exports = __webpack_public_path__ + "img/pr_7.2c2c73a4.png";